module.exports = __webpack_public_path__ + "static/media/hero06.3cf9af19.mp4";